export default "__VITE_ASSET__8a314ab4__"